<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-toolbar dense flat>
        <v-spacer></v-spacer>
        <v-btn @click="close" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form>
        <v-card-text transition="fade-transition" v-if="internalApprove">
          <div class="text-center title">
            <v-icon color="secondary" size="75">rate_review</v-icon>
            <p>Approve Drafts</p>
          </div>
          <v-container>
            <v-row xs="12">
              <v-alert color="info" icon="info" outlined>{{notes.internalApproveWarning}}</v-alert>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text transition="fade-transition" v-else>
          <div class="text-center title">
            <v-icon color="secondary" size="75">rate_review</v-icon>
            <p>Rate & Review</p>
          </div>
          <v-container>
            <v-flex xs12>
              <p class="subtitle-1">Kindly Rate Influencer's Quality of Works</p>
              <v-rating
                v-model="submissionReview.approveRatings"
                color="secondary"
                size="45"
              ></v-rating>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs12>
              <v-expand-transition>
                <div
                  v-show="submissionReview.approveRatings > 0 && submissionReview.approveRatings <= 4"
                >
                  <p class="subtitle-1">
                    <v-textarea
                      filled
                      label="How can we make this a 5 stars?"
                      v-model="submissionReview.approveSuggestion"
                    ></v-textarea>
                  </p>
                  <v-divider></v-divider>
                </div>
              </v-expand-transition>
              <v-expand-transition>
                <div
                  v-show="submissionReview.approveRatings > 0 && submissionReview.approveRatings == 5"
                >
                  <p class="subtitle-1">
                    <v-textarea
                      filled
                      label="Leave Influencer a compliment?"
                      v-model="submissionReview.approveCompliment"
                    ></v-textarea>
                  </p>
                  <v-divider></v-divider>
                </div>
              </v-expand-transition>
              <v-alert color="info" icon="info" outlined>{{notes.beforeStart}}</v-alert>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="internalApprove" dark block color="green" @click="submitApproveInternal()">Approve All</v-btn>
          <v-btn v-else dark block color="green" @click="submitApprove()">Approve All</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import PostAPIs from './postApi';
import postConfig from './postConfig';
import moment from 'moment'
import utils from '@/utils'
export default {
  props: {
    posts: Array,
    value: Boolean,
    internalApprove: Boolean
  },
  data() {
    return {
      loading: false,
      submissionReview: {
        approveRatings: null,
        approveSuggestion: null,
        approveCompliment: null
      }
    };
  },
  computed: {
    notes: () => postConfig.submissionReviewNotes
  },
  methods: {
    reset() {
      this.submissionReview = {
        approveRatings: null,
        approveSuggestion: null,
        approveCompliment: null
      }
    },
    close() {
      this.reset()
      this.$emit('input')
    },
    submitApprove() {
      if (this.submissionReview.approveRatings === null) {
        this.$swal({
          title: 'Rating is required',
          type: 'warning'
        })
      } else if (this.submissionReview.approveSuggestion === null &&
        this.submissionReview.approveCompliment === null) {
        this.$swal({
          title: 'Your comment is required',
          type: 'warning'
        })
      } else {
        let data = [];
        let body = {
          rating: this.submissionReview.approveRatings,
          comment: this.submissionReview.approveSuggestion || this.submissionReview.approveCompliment,
          postDate: null, // we won't let the influencers change the date for bulk approves
          appLink: window.location.protocol + '//' + window.location.host
        };
        for (let item of this.posts) {
          if (item.postDate < utils.func.formatCustomDate(moment(), 'YYYY-MM-DD')) {
            body.isDateOverdue = true
          }
          body.postDate = item.postDate
          body.isApprove = true
          data.push({
            id: item._id,
            body
          });
        }
        this.$swal({
          type: 'question',
          title: 'Do you want to approve all the selected posts?',
          confirmButtonText: 'Yes, Approve',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true
        }).then(result => {
          if (result.value) {
            PostAPIs.clientApprovePost(data)
              .then(() => {
                this.$swal({
                  type: 'success',
                  title: 'Approved'
                }).then(() => {
                  this.$emit('successBulkApprove')
                  this.close()
                });
              })
              .catch(() =>
                this.$swal({
                  type: 'error',
                  title: 'Some thing went wrong'
                }).then(() => this.close())
              );
          }
        });
      }
    },
    submitApproveInternal() {
      if (this.posts.length <= 0) {
        this.$swal({
          title: 'Please select at least one post.',
          type: 'warning'
        })
      } else {
        let data = [];
        let body = {
          rating: null,
          comment: null,
          internalApproved: true,
          appLink: window.location.protocol + '//' + window.location.host
        };
        for (let item of this.posts) {
          data.push({
            id: item._id,
            body
          });
        }
        this.$swal({
          type: 'question',
          title: 'Do you want to approve all the selected posts?',
          confirmButtonText: 'Yes, Approve',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true
        }).then(result => {
          if (result.value) {
            PostAPIs.clientApprovePost(data)
              .then(() => {
                this.$swal({
                  type: 'success',
                  title: 'Approved'
                }).then(() => {
                  this.$emit('successBulkApprove')
                  this.close()
                });
              })
              .catch(() =>
                this.$swal({
                  type: 'error',
                  title: 'Some thing went wrong'
                }).then(() => this.close())
              );
          }
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// SubmissionReviewMultiple.vue?14882075